// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/save_assay_as_response.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssayData } from "./assay_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_assay_data } from "./assay_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/save_assay_as_response.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_save_assay_as_response: GenFile = /*@__PURE__*/
  fileDesc("CkRxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvc2F2ZV9hc3NheV9hc19yZXNwb25zZS5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxInEKE1NhdmVBc3NheUFzUmVzcG9uc2USSwoKYXNzYXlfZGF0YRgBIAEoCzIyLnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5Bc3NheURhdGFIAIgBAUINCgtfYXNzYXlfZGF0YWIGcHJvdG8z", [file_quanterix_simoa_one_analysis_app_api_v1_assay_data]);

/**
 * Rpc response containing saved assay data
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.SaveAssayAsResponse
 */
export type SaveAssayAsResponse = Message<"quanterix.simoa_one.analysis_app_api.v1.SaveAssayAsResponse"> & {
  /**
   * The saved assay data
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.AssayData assay_data = 1;
   */
  assayData?: AssayData;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.SaveAssayAsResponse.
 * Use `create(SaveAssayAsResponseSchema)` to create a new message.
 */
export const SaveAssayAsResponseSchema: GenMessage<SaveAssayAsResponse> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_save_assay_as_response, 0);

